import iconfont from "@/util/font/iconfont"
import { createFromIconfontCN } from "@ant-design/icons"
const IconFont = createFromIconfontCN({
	scriptUrl: iconfont,
})

export default IconFont
